module.exports = __webpack_public_path__ + "iPhone11-Red@2x.png?47019676d317924c64f9eeb2ac066848";